import React, { useState, useContext } from 'react'
import { useSearchParams } from 'react-router-dom'
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import { Button, Input, Form } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import api from '../../services/api';
import styles from '../../services/styles';
import { displayMessage } from '../../services/helper';

const { tc1, tc2, bc1, bc2 } = styles

export function ResetPassword() {

    const [searchParams, setSearchParams] = useSearchParams();

    const token = searchParams.get('token')

    const { mobile_mode, setLoggedUser } = useContext(GeneralContext)

    const [newPassword, setNewPassword] = useState(null)
    const [oldPassword, setOldPassword] = useState(null)
    const [confirmedNewPassword, setConfirmedNewPassword] = useState(null)

    const onFinish = () => {

        if (!newPassword || !confirmedNewPassword) { alert(displayMessage('FILL_ALL_FIELDS_RESET_PASSWORD')); return }
        if (newPassword != confirmedNewPassword) { alert(displayMessage('PASSWORD_CONFIRMATION_FAILED')); return }

        api.auth.resetPassword({ oldPassword, newPassword }).then(
            rs => {
                if (rs.status == 200) {
                    alert(displayMessage('RESET_PASSWORD_SUCCESS'), "success")
                    setTimeout(
                        () => {
                            setLoggedUser(false)
                        }
                    , 1500 
                    ) 
                    

                }
            }
        )

    }

    return (
        <div>
            <div style={{ width: '100%', height: window.innerHeight, display: 'flex' }}>

                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, marginLeft: '3rem' }}>
                        <div style={{ color: tc1, fontWeight: 'bold', marginBottom: 15, fontSize: mobile_mode ? 11 : 24 }}>{displayMessage('REDEFINE_PASSWORD')}</div>

                        <Form
                            name="reset_password"
                            labelCol={{ span: 25 }}
                            wrapperCol={{ span: 80 }}
                            //wrapperRow={{ span: 80 }}
                            onFinish={onFinish}
                            style={{ textAlign: 'center', width: '65%' }}
                        >
                             <Form.Item
                                name="old_password"
                                rules={[{ required: true, message: displayMessage('DISPLAY_PASSWORD') }]}
                            >
                                <Input
                                    prefix={<LockOutlined className="site-form-item-icon" />}
                                    type="password"
                                    autoComplete="do-not-use-auto-complete"
                                    placeholder={displayMessage('OLD_PASSWORD')}
                                    value={newPassword}
                                    onChange={
                                        e => {
                                            setOldPassword(e.target.value)
                                        }
                                    }
                                    style={{ border: 'solid 1px rgb(92, 43, 129)', height: 40 }}
                                />
                            </Form.Item>


                            <Form.Item
                                name="new_password"
                                rules={[{ required: true, message: displayMessage('DISPLAY_PASSWORD') }]}
                            >
                                <Input
                                    prefix={<LockOutlined className="site-form-item-icon" />}
                                    type="password"
                                    autoComplete="do-not-use-auto-complete"
                                    placeholder={displayMessage('NEW_PASSWORD')}
                                    value={newPassword}
                                    onChange={
                                        e => {
                                            setNewPassword(e.target.value)
                                        }
                                    }
                                    style={{ border: 'solid 1px rgb(92, 43, 129)', height: 40 }}
                                />
                            </Form.Item>

                            <Form.Item
                                name="confirm_password"
                                rules={[{ required: true, message: displayMessage('DISPLAY_CONFIRM_PASSWORD') }]}
                            >
                                <div>
                                    <Input
                                        prefix={<LockOutlined className="site-form-item-icon" />}
                                        type="password"
                                        value={confirmedNewPassword}
                                        placeholder={displayMessage('CONFIRM_NEW_PASSWORD')}
                                        onChange={
                                            e => {
                                                setConfirmedNewPassword(e.target.value)
                                            }
                                        }
                                        style={{ border: 'solid 1px rgb(92, 43, 129)', height: 40 }}
                                    />
                                </div>

                            </Form.Item>

                            <Form.Item hasFeedback >
                                <Button type="primary" style={{ width: "100%" }} htmlType="submit">
                                    {displayMessage('REDEFINE_PASSWORD')}
                                </Button>
                            </Form.Item>

                        </Form>
                    </div>
            </div>

        </div>
    )
}

